var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankNh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "#004F14"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3L16.4971 4.84875L13 3L16.4971 10L20 3Z",
    fill: "#FABE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7706 8.27992L20.7243 8.25343L22.9818 7.28245V4.00004L19.0583 5.71507L16.8832 9.9369C18.6194 10.1465 19.8954 11.7089 19.793 13.4999C19.6908 15.291 18.2456 16.6897 16.4974 16.6897C14.7492 16.6897 13.3041 15.291 13.2019 13.4999C13.0995 11.7089 14.3755 10.1464 16.1117 9.9369L13.9417 5.71507L10.0029 4V7.26135L12.2808 8.25338L12.2294 8.30088C10.1864 10.1284 9.46262 13.065 10.4134 15.6696C11.3641 18.2741 13.7899 20 16.5 20C19.2102 20 21.6359 18.2741 22.5866 15.6697C23.5374 13.065 22.8136 10.1284 20.7706 8.30093V8.27992Z",
    fill: "#FABE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankNh);
export default __webpack_public_path__ + "static/media/BankNH.5fa8399f2d3d6b1a09291a0a67d19be7.svg";
export { ForwardRef as ReactComponent };